export const style = {
  nonEditable: {
    cursor: `default`
  },
  content: {
    color: `#666`
  },
  edit: {
    color: `black`
  },
  nonEditableEdit: {
    opacity: 0
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/ColorBlind/tableRow.js